import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * Utility functions for the Red Flag Filter app
 */

// Format date for display
export function formatDate(date: Date): string {
  const now = new Date()
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const yesterday = new Date(today)
  yesterday.setDate(yesterday.getDate() - 1)

  if (date >= today) {
    return `Today, ${date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}`
  } else if (date >= yesterday) {
    return `Yesterday, ${date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}`
  } else {
    return date.toLocaleDateString([], { month: "short", day: "numeric", year: "numeric" })
  }
}

// Generate a random string
export function generateRandomString(length: number): string {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
  let result = ""

  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length))
  }

  return result
}

// Validate email format
export function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}

// Sanitize user input
export function sanitizeInput(input: string): string {
  return input.trim().replace(/</g, "&lt;").replace(/>/g, "&gt;")
}

// Handle API errors
export function handleApiError(error: any): { message: string; status: number } {
  console.error("API Error:", error)

  if (error.name === "JsonWebTokenError") {
    return { message: "Invalid token", status: 401 }
  }

  if (error.name === "TokenExpiredError") {
    return { message: "Token expired", status: 401 }
  }

  if (error.code === "P2002") {
    return { message: "This email is already in use", status: 400 }
  }

  if (error.code === "P2025") {
    return { message: "Record not found", status: 404 }
  }

  return { message: error.message || "Internal server error", status: 500 }
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

